import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const setCookie = (name, value, seconds = 31557600) => {
  return cookies.set(name, value, { maxAge: seconds, path: '/' })
}
export const getCookie = name => {
  return cookies.get(name)
}
export const removeCookie = name => {
  return cookies.remove(name, { path: '/' })
}
